import { SET_OUTCOME_VALUE } from './actionTypes'

export const setOutcomeValue = actionPayload => (
  { type: SET_OUTCOME_VALUE, ...actionPayload }
)



// WEBPACK FOOTER //
// ./src/state/actions/outcomeValue.js